import React from "react";
import ReactApexChart from "react-apexcharts";

class LineChart extends React.Component {
  render() {
    return (
      <ReactApexChart
        options={this.props.chartOptions}
        series={this.props.chartData}
        type="line"
        width="100%"
        height="100%"
      />
    );
  }
}

export default LineChart;
